import { getRuleAsInteger } from '../../../../state/models/facility'
import { futureBookingsForUnits } from '../../../../state/stores/bookings'
import { IFacilityModel } from '../../../../interfaces/models/facilities.interfaces'
import { IBookingModel } from '../../../../interfaces/models/bookings.interfaces'

export const useUserReachedMaxBookings = (
  unitId: string,
  facility: IFacilityModel,
  facilityBookings: IBookingModel[]
): boolean => {
  if (!facility) {
    return false
  }

  if (facility?.rules === 'unlimited') {
    return false
  }
  const futureFacilityBookings = futureBookingsForUnits(
    [unitId],
    facilityBookings || []
  )

  const maxNumberOfBookings = getRuleAsInteger(facility.rules)

  return futureFacilityBookings.length >= maxNumberOfBookings
}
